import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LoginService } from 'src/app/pages/login-dialog/login.service';
import { ResponsibleApi } from 'src/app/shared/apis/responsible.api';
import { CustomerServiceService } from 'src/app/shared/components/customer-service/customer-service.service';
import { ToastService } from 'src/app/shared/service/toast.service';
import { PipesModule } from '../../pipes/pipes.module';
import { CountdownLimitComponent } from '../countdown-limit/countdown-limit.component';
import { CSButtonComponent } from '../cs-button/cs-button.component';
import { CSIconButtonComponent } from '../cs-icon-button/cs-icon-button.component';

export type TimeoutState = 'timeout' | 'reopen';

@Component({
  selector: 'app-timeout-countdown-dialog',
  standalone: true,
  imports: [CountdownLimitComponent, CSButtonComponent, CSIconButtonComponent, CommonModule, PipesModule],
  templateUrl: './timeout-countdown-dialog.component.html',
  styleUrls: ['./timeout-countdown-dialog.component.scss'],
})
export class TimeoutCountdownDialogComponent implements OnInit {
  state: TimeoutState = 'timeout';
  startTime: number = 0;
  endTime: number = 0;
  reopenTime: number = 0;
  isLoading: boolean = false;
  isTimeoutComplete: boolean = false;
  isReopenComplete: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      startUnixTimestamp: number;
      endUnixTimestamp: number;
      period: number;
      reopenKey: string;
      reopenUnixTimestamp: number;
    },
    private dialogRef: MatDialogRef<TimeoutCountdownDialogComponent>,
    private responsibleApi: ResponsibleApi,
    private toast: ToastService,
    private loginService: LoginService,
    private customerServiceService: CustomerServiceService,
  ) {}

  ngOnInit() {
    this.state = this.data.reopenUnixTimestamp ? 'reopen' : 'timeout';
    this.calculateTimes();
  }

  calculateTimes() {
    this.startTime = this.data.startUnixTimestamp;
    this.endTime = this.data.reopenUnixTimestamp ? this.data.reopenUnixTimestamp : this.data.endUnixTimestamp;
  }

  close() {
    this.dialogRef.close();
  }

  onReopenAccount() {
    if (this.state === 'timeout' && this.isTimeoutComplete) {
      // timeout 倒数完成后，点击 Log in 按钮打开登录弹窗
      this.dialogRef.close();
      this.loginService.openLogin();
      return;
    }

    if (this.state === 'reopen' && this.isReopenComplete) {
      // reopen 倒数完成后，点击 Log in 按钮打开登录弹窗
      this.dialogRef.close();
      this.loginService.openLogin();
      return;
    }

    // timeout 倒数未完成，调用 API 请求提前结束 timeout
    if (!this.data.reopenKey) {
      this.toast.show({ message: 'Missing reopen key', type: 'fail' });
      return;
    }

    this.isLoading = true;
    this.responsibleApi.requestEarlyReopen(this.data.reopenKey).subscribe({
      next: result => {
        this.isLoading = false;
        if (result?.success && result.data) {
          // 进入 reopen 状态
          this.state = 'reopen';
          this.endTime = result.data.reopenUnixTimestamp;
        } else {
          this.toast.show({ message: result?.message || 'Request failed', type: 'fail' });
        }
      },
      error: () => {
        this.isLoading = false;
        this.toast.show({ message: 'Request failed', type: 'fail' });
      },
    });
  }

  onCountdownComplete() {
    if (this.state === 'reopen') {
      // reopen 倒数完成，显示登录按钮
      this.isReopenComplete = true;
    } else {
      // timeout 倒数完成，按钮文案改为 Log in
      this.isTimeoutComplete = true;
    }
  }

  /** 打开客服面板 */
  toService() {
    if (this.customerServiceService.chatReady()) {
      switch (this.customerServiceService.chatType) {
        case 'liveChat':
          this.customerServiceService.liveChatConfig.visibility = 'maximized';
          break;
        case 'zendesk':
          if (window.zE) window.zE('messenger', 'open');
          break;
        default:
          break;
      }
    }
  }
}
